module.exports = "<section class=\"tab {{tabStyleClassName}}\" role=\"tablist\">\n    <a href=\"#\" role=\"tab\"  *ngFor=\"let data of tabConfig\" [ngClass]=\"{'selected': selectedTab == data.id }\" (click)=\"tabClick(data.id,$event)\">\n        <i18n-msg key='{{data.title}}' remark=\"tab title\"></i18n-msg>\n    </a>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tab/tab.component.html
// module id = ./src/app/components/tab/tab.component.html
// module chunks = main